/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSynevoSelectedCostDto
 */
export interface GetSynevoSelectedCostDto {
    /**
     * 
     * @type {number}
     * @memberof GetSynevoSelectedCostDto
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof GetSynevoSelectedCostDto
     */
    amount: string;
}

/**
 * Check if a given object implements the GetSynevoSelectedCostDto interface.
 */
export function instanceOfGetSynevoSelectedCostDto(value: object): value is GetSynevoSelectedCostDto {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function GetSynevoSelectedCostDtoFromJSON(json: any): GetSynevoSelectedCostDto {
    return GetSynevoSelectedCostDtoFromJSONTyped(json, false);
}

export function GetSynevoSelectedCostDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSynevoSelectedCostDto {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'amount': json['amount'],
    };
}

export function GetSynevoSelectedCostDtoToJSON(value?: GetSynevoSelectedCostDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'amount': value['amount'],
    };
}

